module.exports = __webpack_public_path__ + "img/sybj.14ad29fc.png";